import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledPercentageBar = styled(Box, {
  display: 'flex',
  height: '$6',
  fontWeight: '$medium',
  fontSize: '$xs',
  lineHeight: '$6',
});

export const StyledPercentageItem = styled(Box, {
  textAlign: 'center',
  fontWeight: '$bold',
  variants: {
    last: {
      true: {
        borderRadius: '0 $4 $4 0',
      },
    },
    first: {
      true: {
        borderRadius: '$4 0 0 $4',
      },
    },
  },
});
